import { useMutation } from "@apollo/client";
import { CreateSavedCourseDocument } from "./graphql/CreateSavedCourse.v4.generated.js";
const useSavedCourse = ()=>{
    const [saveCourseMutation] = useMutation(CreateSavedCourseDocument, {
        context: {
            clientName: 'v4'
        }
    });
    const saveCourse = (courseId)=>saveCourseMutation({
            variables: {
                course_id: courseId
            }
        }).then((response)=>!!response.data?.createSavedCourse?.success);
    return {
        saveCourse
    };
};
const useSaveCourse = useSavedCourse;
export default useSaveCourse;
